import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userLogOut } from '../../-global-state/actions/user-actions';
import './home.css';

const Home = props => {
    return (
        <div id="home">
            <div className="container">

                {props.userLoggedIn
                ? <div className="row pt-5">
                    <div className="col-12 text-end">
                        <Link to="/profile">
                            <button type="button" className="btn btn-outline-success mx-3">
                                <h3 className="text-white px-2">Profile</h3>
                            </button>
                        </Link>
                        <button type="button" className="btn btn-outline-danger" onClick={() => props.userLogOut(localStorage.getItem("token"))}>
                            <h3 className="text-white px-2">Log Out</h3>
                        </button>
                    </div>
                </div>
                : <div className="row pt-5">
                    <div className="col-12 text-end">
                        <Link to="/login">
                            <button type="button" className="btn btn-outline-success mx-3">
                                <h3 className="text-white px-2">Log In</h3>
                            </button>
                        </Link>
                        <Link to="/signup">
                            <button type="button" className="btn btn-success">
                                <h3 className="text-white px-2">Sign Up</h3>
                            </button>
                        </Link>
                    </div>
                </div>
                }

            </div>
            <div className="container d-flex align-items-center justify-content-center home-container fade-in-fwd">

                <div className="row">
                    <div className="col-12 text-center">
                        <h1 className="display-1 text-white text-decoration-underline py-2">Bargain-Basket</h1>
                    </div>
                    <div className="col-12 text-center">
                        <h3 className="display-3 text-secondary py-2">Good Old Fashioned Investing</h3>
                    </div>
                    <div className="col-12 text-center">
                        <span className="text-secondary py-3">Access a comprehensive list of stocks that are selling for less than NCAV (Stock Screener)</span>
                    </div>
                    {/* <div className="col-12 text-center">
                        <span className="text-secondary py-3">*Works best under "normal" market conditions.</span>
                    </div> */}
                    <div className="col-12 text-center py-4">
                        <Link to="/bargains">
                            <button type="button" className="btn btn-outline-dark w-50">
                                <h3 className="text-white display-6 fs-2 py-1">View Bargains</h3>
                            </button>
                        </Link>
                    </div>
                    {/* <div className="col-12 text-center">
                        <small className="text-warning">Bargain Basket is currently on a test server. Users may experience user inputs being cut out or delayed. Please proceed with caution and discretion at this time. Otherwise, check back later this Spring when Bargain Basket will be upgraded and running accordingly. Thanks :)</small>
                    </div> */}
                </div>

            </div>
            <div className="container d-flex align-items-center justify-content-center fade-in-fwd">
                <div className="row text-center">
                    <div className="col-12">
                        <small>
                            <i className="text-secondary">Contact: <a href="mailto:support@bargain-basket.com" className='text-secondary'>support@bargain-basket.com</a></i>
                        </small>
                    </div>
                    <div className="col-12">
                        <small>
                            <i className="text-secondary">© {new Date().getFullYear()} Built & Designed by <a href='https://traegerwinndev.com/' className='text-secondary'>Traeger Winn</a></i>
                        </small>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        userLoggedIn: state.userState.userLoggedIn,
    }
  }

export default connect(mapStateToProps, { userLogOut })(Home);